import React from "react";
import { Link } from "react-router-dom";
import AppStoreLinks from "./AppStoreLinks";
import "../styles/SiteFooter.css";

const SiteFooter = () => (
  <footer className="site-footer">
    <div className="site-footer__inner">
      <div>
        <p className="site-footer__brand">CRAFT</p>
        <p className="site-footer__copy">
          A social beer community for people of legal drinking age.
        </p>
      </div>
      <AppStoreLinks compact />
      <nav className="site-footer__nav" aria-label="Footer navigation">
        <Link to="/about">About</Link>
        <Link to="/support">Support</Link>
        <Link to="/privacy-policy">Privacy</Link>
        <Link to="/terms">Terms</Link>
      </nav>
    </div>
    <p className="site-footer__legal">
      © {new Date().getFullYear()} CRAFT — The Social Beer App
    </p>
  </footer>
);

export default SiteFooter;
